export default __webpack_public_path__ + "static/media/minicard3.35e21c56.jpg";